<template>
  <v-container class="d-flex flex-column ga-3">
    <v-row>
      <v-col>
        <UsageExample v-model="tab" :code="code" :tabs="tabs">
          <v-card elevation="4">
            <v-card-title>Helix Trackers</v-card-title>
            <HxTrackers v-model="currentStep" :items="items" variant="horizontal" />
            <v-btn color="primary" class="ma-2" @click="showHxModalButton = true">HxTrackers</v-btn>
            <HxModal
              v-model="showHxModalButton"
              title="HxTrackers"
              :primary-action="{
                label: 'Next',
                variant: 'primary'
              }"
              :secondary-action1="{
                label: 'Cancel',
                variant: 'secondary'
              }"
              @primary-click="currentStep++"
              @secondary1-click="showHxModalButton = false"
            >
              <template #content>
                <HxTrackers v-model="currentStep" :items="items">
                  <template v-for="(item, index) in items" :key="index" #[`item.${index+1}`]>
                    {{ escapeCodeStringSlot(index + 1) }}
                  </template>
                </HxTrackers>
              </template>
            </HxModal>
          </v-card>
          <span class="d-flex flex-row justify-space-between">
            <v-card class="my-5" elevation="4" width="400">
              <v-card-title>Helix Vertical Trackers</v-card-title>
              <v-card width="400" height="400">
                <HxTrackers
                  :model-value="1"
                  :items="computedVerticalTracker"
                  variant="vertical"
                  @title-button-click="handleTitleButtonClick"
                  @subtitle-button-click="handleSubtitleButtonClick"
                />
              </v-card>
            </v-card>
            <v-card class="my-5" elevation="4" width="250">
              <div class="ma-3">
                <hx-checkbox v-model="showTitleButton" label="Show Title Button" />
                <hx-checkbox v-model="showSubtitleButton" label="Show Subtitle Button" />
              </div>
            </v-card>
          </span>
        </UsageExample>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixTrackers',
  components: { UsageExample },
  setup() {
    // escape `item.${index+1}`
    const specialSymbol = {
      backtick: '`',
      dollar: '$',
      curlyBracketOpen: '{',
      curlyBracketClose: '}'
    };
    const templateLiteral = specialSymbol.backtick;
    let codeString = 'item.';
    codeString += specialSymbol.dollar;
    codeString += specialSymbol.curlyBracketOpen;
    codeString += 'index+1';
    codeString += specialSymbol.curlyBracketClose;

    const code = `
<HxTrackers
  v-model="currentStep"
  variant="horizontal"
  :items="[
        { title: 'Step 1', subtitle: 'Subtitle 1', state: 'complete' },
        { title: 'Step 2', subtitle: 'Subtitle 2', state: 'error' },
        { title: 'Step 3', subtitle: 'Subtitle 3', state: 'skip' },
        { title: 'Step 4', subtitle: 'Subtitle 4' },
        { title: 'Step 5', subtitle: 'Subtitle 5' },
        { title: 'Step 6', subtitle: 'Subtitle 6', state: 'current' },
        { title: 'Step 7', subtitle: 'Subtitle 7', state: 'past' }
      ]"
/>
<v-btn color="primary" class="ma-2" @click="showHxModalButton = true">HxTrackers</v-btn>
<HxModal
  v-model="showHxModalButton"
  title="HxTrackers"
  :primary-action="{
    label: 'Next',
    variant: 'primary'
  }"
  :secondary-action1="{
    label: 'Cancel',
    variant: 'secondary'
  }"
  @primary-click="currentStep++"
  @secondary1-click="showHxModalButton = false"
>
  <template #content>
    <HxTrackers v-model="currentStep" :items="items">
      <template v-for="(item, index) in items" :key="index" #[${templateLiteral}${codeString}${templateLiteral}]>
        Insert your content here
      </template>
    </HxTrackers>
  </template>
</HxModal>

<HxTrackers
  v-model="currentStep"
  :items="[
        { title: 'Step 1', subtitle: 'Subtitle 1', state: 'complete' },
        { title: 'Step 2', subtitle: 'Subtitle 2', state: 'error' },
        { title: 'Step 3', subtitle: 'Subtitle 3', state: 'skip' },
        { title: 'Step 4', subtitle: 'Subtitle 4' },
        { title: 'Step 5', subtitle: 'Subtitle 5' },
        { title: 'Step 6', subtitle: 'Subtitle 6', state: 'current' },
        { title: 'Step 7', subtitle: 'Subtitle 7', state: 'past' }
      ]"
  variant="vertical"
  @title-button-click="handleTitleButtonClick(item, index)" 
  @subtitle-button-click="handleSubtitleButtonClick(item, index)" 
/>
    `;
    return { code };
  },
  data() {
    return {
      tab: 'Trackers Usage',
      tabs: ['Trackers Usage'],
      currentStep: 4,
      items: [
        { title: 'Step 1', subtitle: 'Subtitle 1', state: 'complete' },
        { title: 'Step 2', subtitle: 'Subtitle 2', state: 'error' },
        { title: 'Step 3', subtitle: 'Subtitle 3', state: 'skip' },
        { title: 'Step 4', subtitle: 'Subtitle 4' },
        { title: 'Step 5', subtitle: 'Subtitle 5' },
        { title: 'Step 6', subtitle: 'Subtitle 6', state: 'current' },
        { title: 'Step 7', subtitle: 'Subtitle 7', state: 'past' }
      ],
      itemsVerticalTracker: [
        {
          title: '15/11/2023 10:14 (Current version)',
          subtitle:
            'CompliSpace has updated the Child Safe Module.The Justice Legislation Amendment (Sexual Offences and Other Matters) Act 2022 (Vic) amend the Crimes Act 1958 (Vic) to insert image-based sexual offences into the Act.',
          state: 'complete'
        },
        {
          title: '07/08/2023 16:03',
          subtitle:
            'CompliSpace has updated the Child Safe Module.The Justice Legislation Amendment (Sexual Offences and Other Matters) Act 2022 (Vic) amend the Crimes Act 1958 (Vic) to insert image-based sexual offences into the Act.',
          state: 'error'
        },
        {
          title: '07/08/2023 16:03',
          subtitle:
            'CompliSpace has updated the Child Safe Module.The Justice Legislation Amendment (Sexual Offences and Other Matters) Act 2022 (Vic) amend the Crimes Act 1958 (Vic) to insert image-based sexual offences into the Act.',
          state: 'skip'
        },
        {
          title: '07/08/2023 16:03',
          subtitle:
            'CompliSpace has updated the Child Safe Module.The Justice Legislation Amendment (Sexual Offences and Other Matters) Act 2022 (Vic) amend the Crimes Act 1958 (Vic) to insert image-based sexual offences into the Act.'
        },
        {
          title: '07/08/2023 16:03',
          subtitle:
            'CompliSpace has updated the Child Safe Module.The Justice Legislation Amendment (Sexual Offences and Other Matters) Act 2022 (Vic) amend the Crimes Act 1958 (Vic) to insert image-based sexual offences into the Act.'
        },
        {
          title: '07/08/2023 16:03',
          subtitle:
            'CompliSpace has updated the Child Safe Module.The Justice Legislation Amendment (Sexual Offences and Other Matters) Act 2022 (Vic) amend the Crimes Act 1958 (Vic) to insert image-based sexual offences into the Act.',
          state: 'current'
        },
        {
          title: '07/08/2023 16:03',
          subtitle:
            'CompliSpace has updated the Child Safe Module.The Justice Legislation Amendment (Sexual Offences and Other Matters) Act 2022 (Vic) amend the Crimes Act 1958 (Vic) to insert image-based sexual offences into the Act.',
          state: 'past'
        }
      ],
      showHxModalButton: false,
      slotCode: '',
      showTitleButton: true,
      showSubtitleButton: true
    };
  },
  computed: {
    escapeCodeStringSlot() {
      // escape <template #[`item.1`]></template>
      return (index) =>
        `<template #[\`item.${index}\`]>
          Insert your content here
          </template>`;
    },
    computedVerticalTracker() {
      return this.itemsVerticalTracker.map((item) => {
        return {
          ...item,
          titleButton: this.showTitleButton ? 'Restore' : undefined,
          subtitleButton: this.showSubtitleButton ? 'Compared to current version' : undefined
        };
      });
    }
  },
  methods: {
    handleTitleButtonClick(item, index) {
      console.log(`Title clicked: ${JSON.stringify(item, null, 2)} at index ${index}`);
    },
    handleSubtitleButtonClick(item, index) {
      console.log(`Subtitle clicked: ${JSON.stringify(item, null, 2)} at index ${index}`);
    }
  }
};
</script>
